export const DRIVER_REQUEST_POSSIBLE_TIME_FROM = 24;
export const DRIVER_REQUEST_POSSIBLE_TIME_TO = 4.5;

export const isDriverRequestPossibleTime = (): boolean => {
  const hour = new Date().getHours();
  const minute = new Date().getMinutes();
  const hour_minute = hour + minute / 60;
  let flg = false;
  if (DRIVER_REQUEST_POSSIBLE_TIME_FROM < DRIVER_REQUEST_POSSIBLE_TIME_TO) {
    // 日をまたがない場合はfromからtoの間
    flg =
      DRIVER_REQUEST_POSSIBLE_TIME_FROM < hour_minute &&
      hour_minute < DRIVER_REQUEST_POSSIBLE_TIME_TO;
  } else {
    // 日をまたぐ場合はfromから24時の間、または0時からtoの間
    flg =
      (DRIVER_REQUEST_POSSIBLE_TIME_FROM < hour_minute && hour_minute < 24) ||
      (0 < hour_minute && hour_minute < DRIVER_REQUEST_POSSIBLE_TIME_TO);
  }
  return flg;
};

export const hourToString = (num): string =>
  ("0" + Math.floor(num)).substr(-2, 2) +
  ":" +
  ("0" + (num % 1) * 60).substr(-2, 2);

export type DriverRequestJSON = {
  id: number;
  origin: string;
  destination: string;
  status: string;
  request_user_id: number;
  driver_user_id: number | null;
  admin_user_id: number | null;
  created_at: string;
  chat_room_id: number | null;
};

export class DriverRequest {
  id: number;
  origin: string;
  destination: string;
  status: string;
  requestUserId: number;
  driverUserId: number;
  adminUserId: number;

  constructor(fields: DriverRequestJSON) {
    this.id = fields.id;
    this.origin = fields.origin;
    this.destination = fields.destination;
    this.status = fields.status;
    this.requestUserId = fields.request_user_id;
    this.driverUserId = fields.driver_user_id;
    this.adminUserId = fields.admin_user_id;
  }

  setId(id: number): void {
    this.id = id;
  }
  setOrigin(origin: string): void {
    this.origin = origin;
  }
  setDestination(destination: string): void {
    this.destination = destination;
  }
  setStatus(status: string): void {
    this.status = status;
  }
  setRequestUserId(request_user_id: number): void {
    this.requestUserId = request_user_id;
  }
  setDriverId(driver_user_id: number): void {
    this.driverUserId = driver_user_id;
  }
  setAdminUserId(admin_user_id: number): void {
    this.adminUserId = admin_user_id;
  }
}
